import { render } from "./index.vue?vue&type=template&id=8eaf5d40&scoped=true&bindings={}"
import script from "./Showcase.js?vue&type=script&lang=js"
export * from "./Showcase.js?vue&type=script&lang=js"

import "./Showcase.scss?vue&type=style&index=0&id=8eaf5d40&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8eaf5d40"

export default script